import { useParams } from 'react-router-dom';

export const useCheckQaSpecLocked = () => {
  const { id: productId } = useParams();

  const qaSpecDataHeader = null;

  const checkQASpecLocked = () => {
    const unlockedStatus = ['submitted', 'approved'];

    return unlockedStatus.includes(qaSpecDataHeader?.status?.toLowerCase());
  };
  const isQASpecLocked = checkQASpecLocked();

  return {
    isQASpecLocked,
  };
};
